import langConf from 'src/translations/langConf';
const storageKey = 'LastSelectedLanguage';
class AppLanguageStorage {
    static defaultLanguage = langConf.defaultLanguage.appFormat;
    static supportedByLogin = langConf.loginPageAllowedLanguages.map((lang) => lang.appFormat);
    static get storedPreference() {
        return localStorage.getItem(storageKey);
    }
    static get languageForLogin() {
        if (this.storedPreference && this.supportedByLogin.includes(this.storedPreference)) {
            return this.storedPreference;
        }
        return this.defaultLanguage;
    }
    static get language() {
        return this.storedPreference || this.defaultLanguage;
    }
    static set language(lang) {
        localStorage.setItem(storageKey, lang);
    }
}
export default AppLanguageStorage;
